// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"8792":"ed447695c038ea339f7d","9289":"0f049ce8d3774ffa4969"}[chunkId] + ".css";
};